import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import { Fragment } from 'react';

import CompanyLogo from './components/CompanyLogo';
import LinkedMemberManagementContainer from './containers/LinkedMemberManagementContainer';
import LinkedMembersContainer from './containers/LinkedMembersContainer';
import PrimaryMemberContainer from './containers/PrimaryMemberContainer';

const LinkedMembersManagementRoute = () => {
	return (
		<Fragment>
			<CssBaseline />
			<Container maxWidth="lg">
				<Stack
					spacing={2}
					sx={{
						pt: '24px',
						maxWidth: 'sm',
						margin: '0 auto 48px'
					}}
				>
					<CompanyLogo />
					<LinkedMemberManagementContainer />
					<Divider />
					<LinkedMembersContainer />
					<PrimaryMemberContainer />
				</Stack>
			</Container>
		</Fragment>
	);
};

export default LinkedMembersManagementRoute;
